function doNothing() {
}

export default doNothing;
